

















































import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import PolicyService from "../../services/policy";
import { Policy } from "@/services/policy/policy.types";

@Component
export default class Policies extends Vue {
  files = [];
  appSelected = "FD";
  apps = [
    "FD",
    "ScanPro",
    "Sudoku",
    "Translator",
    "Scanner",
    "ScanGuru",
    "Lap",
    "Coobrick",
    "BH",
    "Mazzy",
    "Cleaner",
    "Vpn"
  ];
  buckets = new Map([
    ["Vpn", "universevpn.app"],
    ["FD", "universeapps.limited/differences"],
    ["ScanPro", "universeapps.limited/scanpro"],
    ["ScanGuru", "universeapps.limited/scanguru"],
    ["Cleaner", "universeapps.limited/cleaner"],
    ["Sudoku", "universeapps.limited/sudoku"],
    ["Translator", "universeapps.limited/translatorguru"],
    ["Scanner", "mobapps.limited/scanner"],
    ["Lap", "universeapps.limited/lap"],
    ["Coobrick", "atomoperations.tech/coobrick"],
    ["BH", "universeapps.limited/bh"],
    ["Mazzy", "universeapps.limited/Mazzy"]
  ]);

  loading3 = false;
  indicators = {
    uploadingPolicy: false
  };

  get getLoading() {
    return Object.values(this.indicators).filter(v => !!v).length > 0;
  }

  // @Watch("files", { deep: true })
  async uploadPolicy() {
    this.indicators["uploadingPolicy"] = true;
    this.files.forEach(async file => {
      const bucket = this.buckets.get(this.appSelected) || "";
      await PolicyService.uploadPolicy(bucket, file);
    });
    setTimeout(() => (this.indicators["uploadingPolicy"] = false), 1000);
  }
}
